import { lookupService } from '@/services';
import i18n from '../i18n';

const state = {
  items: [],
  detail: null,
  availableLookups: []
};

const actions = {
  getAll({ commit }: any) {
    lookupService
      .getAll()
      .then(
        lookups => commit('getAllSuccess', lookups),
        error => console.log(error)
      )
      .finally();
  },
  getById({ commit }: any, id: any) {
    lookupService
      .getById(id)
      .then(
        lookup => commit('getByIdSuccess', lookup),
        error => console.log(error)
      )
      .finally();
  },
  getAvailableLookup({ commit }: any, id: any) {
    if (!state.availableLookups.find((lookup: any) => lookup.id === id)) {
      lookupService
        .getById(id)
        .then(
          lookup => commit('getAvailableLookupSuccess', lookup),
          error => console.log(error)
        )
        .finally();
    }
  },

  updateLookupItem({ dispatch, commit }: any, { lookupId, id, lookupItem }: any) {
    lookupService
      .updateLookupItem(lookupId, id, lookupItem)
      .then(
        () => {
          dispatch('alert/success', `notification.lookupItemUpdated`, {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getById', lookupId));
  },

  createLookupItem({ dispatch, commit }: any, { id, lookupItem }: any) {
    lookupService
      .createLookupItem(id, lookupItem)
      .then(
        () => {
          dispatch('alert/success', `notification.lookupItemCreated`, {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getById', id));
  },

  updateLookup({ dispatch, commit }: any, { id, lookup }: any) {
    lookupService
      .updateLookup(id, lookup)
      .then(
        () => {
          dispatch('alert/success', `notification.lookupUpdated`, {
            root: true
          });
        },
        error => {
          dispatch('alert/error', JSON.stringify(error), {
            root: true
          });
        }
      )
      .finally(() => dispatch('getById', id));
  }
};

const mutations = {
  getAllSuccess(state: any, lookups: any) {
    state.items = lookups;
  },
  getByIdSuccess(state: any, lookup: any) {
    state.detail = lookup;
  },
  getAvailableLookupSuccess(state: any, lookup: any) {
    state.availableLookups.push(lookup);
  },
  clearLookup(state: any, id: number) {
    console.log(id);
    state.availableLookups = state.availableLookups.filter((lookup: any) => lookup.id !== id);
  }
};

const getters = {
  getLookupDetail: (state: any, getters: any) => (id: number) => {
    return state.availableLookups.find((lookup: any) => lookup.id === id) ? state.availableLookups.find((lookup: any) => lookup.id === id).description : '';
  },
  getLookupItems: (state: any, getters: any) => () => {
    return state.detail.items.filter((item: any) => !item.isDisabled);
  },
  getAvailableLookupDetail: (state: any, getters: any) => (id: number) => {
    return state.availableLookups.find((lookup: any) => lookup.id === id)
      ? state.availableLookups
          .find((lookup: any) => lookup.id === id)
          .items.map((item: any) => {
            if (i18n.locale === 'en' && item.value2) {
              item.value = item.value2;
            }

            return item;
          })
      : [];
  }
};

export const lookup = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
